import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { Currency } from '@work4all/models/lib/Classes/Currency.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { currencyAsSign } from '@work4all/utils';

import { settings, useSetting } from '../settings';

import { buildQuery } from './data-provider/utils/buildQuery';

type GetLeadCurrency = { getWaehrungen: Currency[] };
const CURRENCY_DATA: Currency = {
  id: null,
  name: null,
};
const query = buildQuery(
  {
    operationName: 'GetLeadCurrency',
    entity: Entities.currency,
    data: CURRENCY_DATA,
  },
  100
);

const DEFAULT_CURRENCY = 'EUR';

export interface LeadCurrency {
  name: string;
  symbol: string;
}

export function useLeadCurrency(): LeadCurrency {
  const result = useQuery<GetLeadCurrency>(query.query, {
    fetchPolicy: 'cache-first',
  });

  const currencies = result.data?.getWaehrungen;
  const leadCurrencyId = useSetting(settings.reserveCurrencyId());
  const leadCurrency = currencies?.find((currency) => {
    return currency.id === leadCurrencyId.value;
  });

  const leadCurrencyName = leadCurrency?.name ?? DEFAULT_CURRENCY;

  return useMemo<LeadCurrency>(() => {
    return {
      name: leadCurrencyName,
      symbol: currencyAsSign(leadCurrencyName),
    };
  }, [leadCurrencyName]);
}
